const actions = {
  SET_STATE: 'document/SET_STATE',
  GET_DOCUMENT: 'document/GET_DOCUMENT',
}

export default actions
